/** The API from the browser: JSON in, JSON out, the bearer token on every call, errors as messages. */
import type { Config, Session } from "./auth.js";

export class ApiError extends Error {
  constructor(public readonly status: number, message: string) { super(message); }
}

export async function loadConfig(): Promise<Config> {
  const res = await fetch("/api/config");
  if (!res.ok) throw new ApiError(res.status, "The API did not answer /api/config.");
  return (await res.json()) as Config;
}

export async function api<T>(session: Session, path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const token = await session.token();
  const res = await fetch(path, {
    method: init.method ?? "GET",
    headers: { authorization: `Bearer ${token}`, ...(init.body !== undefined ? { "content-type": "application/json" } : {}) },
    ...(init.body !== undefined ? { body: JSON.stringify(init.body) } : {}),
  });
  if (!res.ok) {
    let message = `${res.status}`;
    try { const j = (await res.json()) as { error?: string }; if (j.error) message = j.error; } catch { /* the body was not JSON; the status is the message */ }
    throw new ApiError(res.status, message);
  }
  return (await res.json()) as T;
}
